import { render } from "./Loading.vue?vue&type=template&id=a566f3c2&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=a566f3c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/nush-bookings/nush-bookings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a566f3c2"]])

export default __exports__